import classNames from "classnames/bind";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GameReportProps } from "../GameReport/GameReport";
import { Aggregated } from "./Aggregated/Aggregated";
import { Detailed } from "./Detailed/Detailed";

import styles from "./TriviaChart.module.scss";

const cx = classNames.bind(styles);

enum ReportMode {
  AGGREGATED = "AGGREGATED",
  DETAILED = "DETAILED",
}

export const TriviaChart = ({ game }: GameReportProps) => {
  const [mode, setMode] = useState(ReportMode.AGGREGATED);
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.modeMenu}>
        <button
          className={cx("modeButton", { active: mode === ReportMode.AGGREGATED })}
          onClick={() => setMode(ReportMode.AGGREGATED)}
        >
          {t("report:trivia.modePicker.aggregated")}
        </button>
        <button
          className={cx("modeButton", { active: mode === ReportMode.DETAILED })}
          onClick={() => setMode(ReportMode.DETAILED)}
        >
          {t("report:trivia.modePicker.detailed")}
        </button>
      </div>

      {mode === ReportMode.AGGREGATED && <Aggregated game={game} />}
      {mode === ReportMode.DETAILED && <Detailed game={game} />}
    </>
  );
};
